"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _core = require("@material-ui/core");

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var useStyles = (0, _core.makeStyles)(function (theme) {
  return {
    root: {
      borderRadius: 6,
      boxShadow: "0 2px 8px ".concat((0, _core.fade)(theme.palette.common.black, 0.16))
    },
    elevation: {
      boxShadow: "0 4px 10px ".concat((0, _core.fade)(theme.palette.common.black, 0.32))
    },
    outlined: {
      borderWidth: 1,
      borderStyle: "solid",
      borderColor: theme.palette.grey[500]
    },
    outlinedWithLabel: {
      overflow: "visible",
      position: "relative",
      borderTopLeftRadius: 0,
      marginTop: theme.spacing(3)
    },
    withLabel: {},
    primary: {
      borderColor: theme.palette.secondary.main
    },
    secondary: {
      borderColor: theme.palette.primary.main
    },
    success: {
      borderColor: theme.palette.success.main
    },
    orange: {
      borderColor: theme.palette.warning.main
    },
    gradient: {
      background: "linear-gradient(90deg, ".concat(theme.palette.primary.dark, ", ").concat(theme.palette.primary.main, ")"),
      "& .MuiTypography-root": {
        color: theme.palette.common.white
      },
      "& .MuiButton-text": {
        color: theme.palette.common.white
      },
      "& .MuiSvgIcon-root": {
        stroke: theme.palette.common.white
      }
    },
    square: {
      borderRadius: 0
    },
    dark: {
      background: theme.palette.grey[700]
    },
    grey: {
      background: theme.palette.grey[100]
    },
    noSpacing: {
      padding: 0
    }
  };
});

var CardContainer = function CardContainer(_ref) {
  var _classNames;

  var label = _ref.label,
      color = _ref.color,
      isSquare = _ref.isSquare,
      isGradient = _ref.isGradient,
      isDark = _ref.isDark,
      isGrey = _ref.isGrey,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["label", "color", "isSquare", "isGradient", "isDark", "isGrey", "children"]);

  var styles = useStyles();
  return /*#__PURE__*/_react.default.createElement(_core.Card, _extends({
    elevation: 0,
    className: (0, _classnames.default)((_classNames = {}, _defineProperty(_classNames, styles.outlined, !!color), _defineProperty(_classNames, styles.root, true), _defineProperty(_classNames, styles.gradient, isGradient), _defineProperty(_classNames, styles.square, isSquare), _defineProperty(_classNames, styles.dark, isDark), _defineProperty(_classNames, styles.grey, isGrey), _defineProperty(_classNames, styles[color], true), _defineProperty(_classNames, styles.outlinedWithLabel, label), _defineProperty(_classNames, styles.withLabel, !!label), _classNames))
  }, props), children);
};

CardContainer.propTypes = {
  /** The Alert color */
  label: _propTypes.default.string,
  color: _propTypes.default.oneOf([null, 'primary', 'secondary', 'success']),
  isGradient: _propTypes.default.bool,
  isSquare: _propTypes.default.bool,
  isDark: _propTypes.default.bool,
  isGrey: _propTypes.default.bool,
  children: _propTypes.default.oneOfType([_propTypes.default.element, _propTypes.default.node])
};
CardContainer.defaultProps = {
  label: null,
  color: null,
  isGradient: false,
  isDark: false,
  isGrey: false,
  isSquare: false,
  children: null
};
var _default = CardContainer;
exports.default = _default;